import { useEffect } from "react";

import {
  AccountMeta,
  AccountSettings,
  useAuth,
} from "@akj-dev/affinity-platform";

const GTM_SCRIPT_AURORA = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-NV94JPB');`;

const GTM_NO_SCRIPT_AURORA = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NV94JPB" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

const GTM_SCRIPT_DWS_SHIMANO = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-5SGC6Z4');`;

const GTM_NO_SCRIPT_DWS_SHIMANO = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5SGC6Z4"
height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

const getInitScript = (dataLayer: DataLayerInitDate) => `
window.dataLayer = window.dataLayer || [];
window.dataLayer.push(${JSON.stringify(dataLayer)})`;

type DataLayerInitDate = AccountMeta &
  AccountSettings & {
    externalUserName: string | undefined;
    event: "accountMeta";
  };

export const useGtm = () => {
  const { accountSettings, accountMeta, externalUserName } = useAuth();

  useEffect(() => {
    const scriptAurora = document.createElement("script");
    scriptAurora.innerHTML = GTM_SCRIPT_AURORA;

    const noScriptAurora = document.createElement("noscript");
    noScriptAurora.innerHTML = GTM_NO_SCRIPT_AURORA;

    const scriptDwsShimano = document.createElement("script");
    scriptDwsShimano.innerHTML = GTM_SCRIPT_DWS_SHIMANO;

    const noScriptDwsShimano = document.createElement("noscript");
    noScriptDwsShimano.innerHTML = GTM_NO_SCRIPT_DWS_SHIMANO;

    document.head.insertBefore(scriptAurora, document.head.childNodes[0]);
    document.body.insertBefore(noScriptAurora, document.body.childNodes[0]);
    document.head.insertBefore(scriptDwsShimano, document.head.childNodes[0]);
    document.body.insertBefore(noScriptDwsShimano, document.body.childNodes[0]);
  }, []);

  useEffect(() => {
    const initScript = document.createElement("script");
    initScript.innerHTML = getInitScript({
      ...accountSettings,
      ...accountMeta,
      externalUserName,
      event: "accountMeta",
    });

    document.head.appendChild(initScript);
  }, [accountSettings, accountMeta, externalUserName]);
};
